<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.dateRange }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateFrom"
                            :label="labels.tranDateFrom"
                            :data-vv-as="labels.tranDateFrom"
                            data-vv-name="forms.tranDateFrom"
                            :error-messages="errors.collect('forms.tranDateFrom')"
                            v-validate="tranDateFromValidation"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateTo"
                            :label="labels.tranDateTo"
                            :data-vv-as="labels.tranDateTo"
                            data-vv-name="forms.tranDateTo"
                            :error-messages="errors.collect('forms.tranDateTo')"
                            v-validate="tranDateToValidation"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.selectionCriteria }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="forms.inclPolNo"
                            :label="labels.inclPolNo"
                            :error-messages="errors.collect('inclPolNo')"
                            data-vv-name="inclPolNo"
                            :data-vv-as="labels.inclPolNo"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('inclPolNo')"
                            v-validate="'required'"
                            readonly
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="forms.exclPolNo"
                            :label="labels.exclPolNo"
                            :error-messages="errors.collect('exclPolNo')"
                            data-vv-name="exclPolNo"
                            :data-vv-as="labels.exclPolNo"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('exclPolNo')"
                            v-validate="'required'"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-btn color="info" dark :loading="processing" @click.prevent="doSubmit">
            {{ labels.export }}
            <!-- <v-icon dark right>mdi-chevron-right</v-icon> -->
            <v-icon dark right>mdi-clipboard-text</v-icon>
          </v-btn>
          <!-- <v-btn-toggle dense mandatory v-model="forms.format">
            <v-btn text>
              <span>{{ labels.format }}</span>
              <v-icon>mdi-clipboard-text</v-icon>
            </v-btn>
          </v-btn-toggle> -->
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="inclPolNoHelpList" width="900px" persistent>
      <multi-polNo-help-list2 :polno="forms.inclPolNo" @close="doClose" @doAssign="doAssign($event)"></multi-polNo-help-list2>
    </v-dialog>

    <v-dialog v-model="exclPolNoHelpList" width="900px" persistent>
      <multi-polNo-exclude-help-list :polno="forms.exclPolNo" @close="doClose" @doAssign="doAssign($event)"></multi-polNo-exclude-help-list>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import clone from 'clone'
// import { downloadPrompt } from '@/utils/file'
import MultiPolNoHelpList2 from '@/components/core/common/dialog/MultiPolNoHelpList2'
import MultiPolNoExcludeHelpList from '@/components/core/common/dialog/MultiPolNoExcludeHelpList'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Range',
        tranDateFrom: 'From Transaction Date*',
        tranDateTo: 'To Transaction Date*',
        selectionCriteria: 'Selection Criteria',
        inclPolNo: 'Include Policy No(s)',
        exclPolNo: 'Exclude Policy No(s)',
        // export: 'Export To',
        export: 'Export',
        format: 'ASCII TEXT'
      },
      forms: {
        tranDateFrom: null,
        tranDateTo: null,
        inclPolNo: 'All',
        exclPolNo: 'None',
        format: 'PDF'
      },
      loading: false,
      processing: false,
      showErrorDialog: false,
      inclPolNoHelpList: false,
      exclPolNoHelpList: false,
      polnoType: undefined,
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    tranDateFromValidation() {
      if (this.forms.tranDateFrom !== '' && this.forms.tranDateFrom !== null && this.forms.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.forms.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.forms.tranDateTo !== '' && this.forms.tranDateTo !== null && this.forms.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.forms.tranDateFrom
      } else {
        return 'required'
      }
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      this.forms.tranDateTo = new Date()
    },
    doClose() {
      this.inclPolNoHelpList = false
      this.exclPolNoHelpList = false
    },
    async doAssign(Obj) {
      if (this.polnoType === 'inclPolNo') {
        this.forms.inclPolNo = Obj.finalSelectedItems.toString()
      } else {
        this.forms.exclPolNo = Obj.finalSelectedItems.toString()
      }
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    // async doExport() {
    //   const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.exportBonPolMOM
    //   if (apiUrl) {
    //     try {
    //       this.processing = true
    //       const result = await this.$http.post(apiUrl, this.forms, {
    //         responseType: 'blob'
    //       })
    //       if (result.data) {
    //         var headers = result.headers
    //         var blob = new Blob([result.data], { type: headers['content-type'] })
    //         var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
    //         downloadPrompt(blob, filename)
    //       }
    //       this.processing = false
    //     } catch (err) {
    //       const { data } = err.response
    //       if (data) {
    //         this.message(data)
    //       }
    //       this.processing = false
    //     }
    //   } else {
    //     this.$toast.error('The request failed because it is trying to execute an invalid API url. [exportWICClaimsGIA]')
    //   }
    // },
    async doExport() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.exportBonPolMOMUOI
      if (apiUrl) {
        try {
          this.processing = true
          let messageFilters = clone(this.forms)
          messageFilters.format = 'PDF'
          await this.$http.post(apiUrl, messageFilters)
          this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    getHelpList(data) {
      if (data === 'inclPolNo') {
        this.inclPolNoHelpList = true
        this.exclPolNoHelpList = false
        this.polnoType = 'inclPolNo'
      } else {
        this.inclPolNoHelpList = false
        this.exclPolNoHelpList = true
        this.polnoType = 'exclPolNo'
      }
    }
  },
  created() {
    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !isAfter(removeTime(value), removeTime(tranFromDate))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !isAfter(removeTime(tranToDate), removeTime(value))
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin],
  components: {
    MultiPolNoHelpList2,
    MultiPolNoExcludeHelpList
  }
}
</script>

<style>
</style>
